<template>
   <div class="plan-item">
      <img class='project-icon' src="@/assets/icons/projectIco.svg" alt="Project Icon" />
      <div class="main-detail">
         <div class='title'>
            <span>{{ plan.name }}</span>
         </div>
         <p>Created By: {{ plan.created_by }}</p>
         <!-- <p>Province: {{ plan.municipality.state }}</p>
         <p>District: {{ plan.municipality.district }}</p> -->
         <p>Municipality: {{ plan.municipality.name }}</p>
         <p>Project Period: {{ plan.period_yr }} years</p> 
         <p>
            Marked complete:
            <span v-if="plan.is_completed" class='yes'>Yes</span>
            <span v-else class='no'>No</span>
         </p> 
         <!-- <p class='date'>Last Updated On: {{ plan.last_updated_at }}</p> -->
         <div class="progressLoader">
            <el-progress
               :text-inside="true"
               :stroke-width="15"
               :percentage="plan.percent_completed"
            />
         </div>
      </div>
      <div class='btns' v-if="plan.created_by_id === user.id || user.role === 'Administrator'">
         <el-button
            @click="editPlan(plan.id)"
            icon="el-icon-edit"
            circle
            size="small"
            content="Edit plan"
            v-tippy
         />
         <el-button
            @click="detailPlan(plan.id)"
            icon="el-icon-tickets"
            circle
            size="small"
            :disabled="planIsComplete"
            content="Show Detail"
            v-tippy
         />
         <el-button
            @click="deletePlan"
            icon="el-icon-delete"
            circle
            size="small"
            content="Delete"
            v-tippy
         />
      </div>
  </div>
</template>

<script>
import { Progress,Button } from 'element-ui';
import { mapGetters } from 'vuex';
import { confirm } from '../../../../../js/ui-helpers';

export default  {
   name: 'plan-list-item',
   components: {
      'el-progress': Progress,
      'el-button': Button,
   },
   props: {
      plan: {
         type: Object,
         required: true,
         validator: plan => [
            "id",
            "name",
            "municipality",
            "created_by",
            "created_by_id",
            "starting_year",
            "ending_year",
            // "last_updated_at",
            "percent_completed",
         ].every(attribute => Object.keys(plan).includes(attribute)),
      },
   },
   computed: {
      ...mapGetters('users', ['user']),
      planIsComplete()
      {
         return this.plan.percent_completed < 100;
      }
   },
   methods: {
      editPlan()
      {
         this.$router.push({ name: "edit-plan", params: { id: this.plan.id }, });
      },
      detailPlan()
      {
         this.$router.push({name: 'final-page', params: {id: this.plan.id} });
      },
      deletePlan()
      {
         confirm({
            title: 'Delete plan',
            msg: `Are you sure you want to delete ${this.plan.name}?`,
            onSuccess: () =>
            {
               this.$emit('delete', this.plan.id);
            } 
         })
      },
   },
}
</script>

<style lang="scss" scoped>
.plan-item {
   display: flex;
   .project-icon {
      margin: 0.2em;
      float: left;
      padding: 0.2em;
      margin-right: 0.5em;
      flex: 0 0 1.2em;
      height: 1.2em;
      border-radius: 50%;
      box-shadow: 0 0 0 1px darken($primary-color, 10%);
   }
   .main-detail {
      font-size: 0.9em;
      color: darken($font-color, 10%);
      flex: 1;
      .title {
         line-height: 1.9;
         font-weight: 500;
         color: darken($primary-color, 10%);
         font-size: 1.05em;
         display: flex;
         justify-items: center;
         margin-bottom: -0.2em;
      }
      p {
         line-height: 1.6;
      }
      .progressLoader {
         margin-top: 6px;
         max-width: 25em;
      }
      .yes {
         color: darken($success-color, 10%);
      }
      .no {
         color: $danger-color;
      }
   }
   .btns {
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      > * {
         margin-bottom: 4px;
      }
   }
}
</style>
